import { render, staticRenderFns } from "./GlobalEvolucion.vue?vue&type=template&id=2517153a"
import script from "./GlobalEvolucion.vue?vue&type=script&lang=js"
export * from "./GlobalEvolucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports